import { Optional } from '@mews/std';
import { getHash } from '../../../utils/getHash';
import { sortOccupancyData } from '../../../utils/sortOccupancyData';
import { OccupancyData } from '../../resourceOrder/occupancyTypes';

interface GetProductPricingHashOptions {
    startDate: string;
    configurationId: string;
    endDate: string;
    occupancyData: Optional<Array<OccupancyData>>;
    currencyCode: string;
}

export const getProductPricingHash = ({
    startDate,
    endDate,
    occupancyData,
    configurationId,
    currencyCode,
}: GetProductPricingHashOptions) =>
    getHash({
        configurationId,
        startDate,
        endDate,
        occupancyData: occupancyData ? sortOccupancyData(occupancyData) : [],
        currencyCode,
    });
